import * as tiff from 'tiff';

const tiffDataToImageData = (tifd: ReturnType<typeof tiff.decode>[0]) => {
  const { data, width, height, components, bitsPerSample } = tifd;
  const length = width * height;
  const d = new Uint8ClampedArray(length * 4);
  const mod = 255 / (bitsPerSample <= 16 ? ((1 << bitsPerSample) - 1) : 1);

  if (components === 1) { // gray
    for (let i = 0; i < length; ++i) {
      d[i * 4] = data[i] * mod;     // r
      d[i * 4 + 1] = data[i] * mod; // g
      d[i * 4 + 2] = data[i] * mod; // b
      d[i * 4 + 3] = 255;           // a
    }
  } else if (components === 2) { // gray + alpha
    for (let i = 0; i < length; ++i) {
      d[i * 4] = data[i * 2] * mod;         // r
      d[i * 4 + 1] = data[i * 2] * mod;     // g
      d[i * 4 + 2] = data[i * 2] * mod;     // b
      d[i * 4 + 3] = data[i * 2 + 1] * mod; // a
    }
  } else if (components === 3) { // rgb
    for (let i = 0; i < length; ++i) {
      d[i * 4] = data[i * 3] * mod;         // r
      d[i * 4 + 1] = data[i * 3 + 1] * mod; // g
      d[i * 4 + 2] = data[i * 3 + 2] * mod; // b
      d[i * 4 + 3] = 255;                   // a
    }
  } else if (components === 4) { // rgb + alpha
    for (let i = 0; i < length; ++i) {
      d[i * 4] = data[i * 4] * mod;         // r
      d[i * 4 + 1] = data[i * 4 + 1] * mod; // g
      d[i * 4 + 2] = data[i * 4 + 2] * mod; // b
      d[i * 4 + 3] = data[i * 4 + 3] * mod; // a
    }
  }
  return new ImageData(d, width, height);
};


export const tiffToPng = async (tiffBlob: Blob) => {
  const buff = await tiffBlob.arrayBuffer();
  const result = tiff.decode(buff);
  if (result.length > 0) {
    const canvas = document.createElement('canvas');
    canvas.width = result[0].width;
    canvas.height = result[0].height;
    const ctx = canvas.getContext('2d');
    if (ctx) {
      const imgData = tiffDataToImageData(result[0]);
      ctx?.putImageData(imgData, 0, 0);
    
      const blob = await new Promise<Blob | null>(reslove => {
        canvas.toBlob(blob => {
          reslove(blob);
        }, 'image/png');
      });
      return blob;
    }
  }
  return null;
};